export class Survey {
  public id: string;
  public email: string;
  public type: string;
  public tagId: string[];
  public completed: boolean;
  public firstname: string;
  public lastname: string;
  public emailSent?: boolean;

  constructor(survey: any) {
    this.id = survey.id;
    this.email = survey.email;
    this.type = survey.type;
    this.tagId = survey.tag;
    this.completed = survey.completed;
    this.firstname = survey.firstname;
    this.lastname = survey.lastname;
    this.emailSent = survey.emailSent;
  }
}

export class SurveyPayload {
  public email: string;
  public type: string;
  public tag?: string[];
  public firstname?: string;
  public lastname?: string;
  public groupType?: string;

  constructor(surveyPayload: any) {
    this.email = surveyPayload.email;
    this.type = surveyPayload.type;
    this.tag = surveyPayload.tag;
    this.firstname = surveyPayload.firstname;
    this.lastname = surveyPayload.lastname;
    this.groupType = surveyPayload.groupType;
  }
}

export class SurveyTag {
  public tagId: string;
  public tagName: string;
  public surveys: Survey[];
  public isOwn?: boolean;
  public visible?: boolean;

  constructor(tag: any) {
    this.tagId = tag.id;
    this.tagName = tag.name;
    this.surveys = tag.surveys;
    this.isOwn = tag.isOwn;
    this.visible = tag.visible;
  }
}

export interface TagModel {
  surveys: Survey[];
  tagId: string;
  tagName: string;
  visible?: boolean;
  isOwn?: boolean;
}

export enum AnswerType {
  APPLIES = 'applies',
  IMPORTANT = 'important',
}

export enum PageStates {
  WELCOME = 'welcome',
  WRITE_TEXT = 'writeText',
  MOTIVE_EXPLANATION = 'motiveExplanation',
  PERSONAL_RESULTS = 'personalResults',
  STRENGTHS_GRAPHIC = 'strengthsGraphic',
  MOTIVE_HIGHLIGHTS = 'motiveHighlights',
  FULL_VERSION = 'fullVersion',
}
